module.exports = __webpack_public_path__ + "static/media/logotipoRodape.b3339ffb.svg";